import script from "./BreadCrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./BreadCrumb.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__